export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
